export default __webpack_public_path__ + "static/media/uncheck.ad838226.svg";